<template>
  <b-modal
    size="md"
    no-close-on-backdrop
    hide-footer
    id="confirmationsOfDutys"
    modal-class="modern-duty-modal"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i :class="['mr-2', duty ? 'fas fa-moon' : 'fas fa-sun']"></i>
        {{ duty ? "Confirme final do plantão" : "Confirme início do plantão" }}
      </div>
    </template>

    <!-- End Duty Content -->
    <div v-if="duty" class="duty-content">
      <div class="duty-header">
        <div class="duty-status-card ending">
          <div class="status-icon">
            <i class="fas fa-moon"></i>
          </div>
          <div class="status-info">
            <h4 class="status-title">Finalizando Plantão</h4>
            <p class="status-subtitle">Adicione observações sobre o período</p>
          </div>
        </div>
      </div>

      <div class="form-section">
        <div class="form-group">
          <label class="form-label">
            <i class="fas fa-comment-dots mr-2"></i>
            Observações do Plantão
          </label>
          <textarea
            v-model="note"
            class="modern-textarea"
            rows="5"
            placeholder="Descreva eventos importantes, ocorrências ou observações relevantes do seu plantão..."
          ></textarea>
          <div class="form-help">
            <i class="fas fa-info-circle mr-1"></i>
            <span>Registre informações importantes para o próximo plantão</span>
          </div>
        </div>
      </div>

      <ErrorsMessages :errors="errors" />

      <div class="modal-actions">
        <v-btn class="btn-end-duty" @click="endDuty" :disabled="loading">
          <i class="fas fa-check mr-2"></i>
          {{ loading ? "Finalizando..." : "FINALIZAR PLANTÃO" }}
        </v-btn>
      </div>
    </div>

    <!-- Start Duty Content -->
    <div v-if="!duty" class="duty-content">
      <div class="duty-header">
        <div class="duty-status-card starting">
          <div class="status-icon">
            <i class="fas fa-sun"></i>
          </div>
          <div class="status-info">
            <h4 class="status-title">Iniciando Plantão</h4>
            <p class="status-subtitle">
              Confirme o início do seu período de trabalho
            </p>
          </div>
        </div>
      </div>

      <div class="duty-info-section">
        <div class="info-card">
          <div class="info-header">
            <i class="fas fa-clock mr-2"></i>
            <span>Informações do Plantão</span>
          </div>
          <div class="info-content">
            <div class="info-item">
              <i class="fas fa-calendar mr-2"></i>
              <span>Data: {{ moment().format("DD/MM/YYYY") }}</span>
            </div>
            <div class="info-item">
              <i class="fas fa-clock mr-2"></i>
              <span>Horário: {{ time }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-actions">
        <v-btn class="btn-start-duty" @click="startDuty" :disabled="loading">
          <i class="fas fa-play mr-2"></i>
          {{ loading ? "Iniciando..." : "INICIAR PLANTÃO" }}
        </v-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import moment from "moment";

export default {
  name: "DashboardDuty",

  components: {
    ErrorsMessages,
  },

  props: {
    duty: [Boolean, Object],
  },

  data() {
    return {
      note: "",

      time: moment().format("HH:mm"),

      loading: false,

      errors: [],
    };
  },

  created() {
    let _this = this;
    setInterval(function () {
      _this.time = moment().format("HH:mm");
    }, 10000);
  },

  methods: {
    moment,

    async endDuty() {
      try {
        this.loading = true;

        let { note } = this;

        let params = {
          note,
        };

        let response = await api.put(
          "/rest-home/duty-control/end-duty",
          params
        );

        let { message, error, errors } = response.data;

        if (!error) {
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.$emit("checkPeriodDuty");

        this.$bvModal.hide("confirmationsOfDutys");

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },

    async startDuty() {
      try {
        this.loading = true;

        let response = await api.put("/rest-home/duty-control/start-duty");

        let { message, error, errors } = response.data;

        if (!error) {
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.$bvModal.hide("confirmationsOfDutys");

        this.$emit("checkPeriodDuty");

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Modal Styling */
.modern-duty-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
}

.modern-duty-modal >>> .modal-body {
  padding: 24px !important;
}

.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

/* Content Layout */
.duty-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Header Section */
.duty-header {
  margin-bottom: 8px;
}

.duty-status-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid;
  transition: all 0.3s ease;
}

.duty-status-card.starting {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  border-color: #f59e0b;
}

.duty-status-card.ending {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  border-color: #818cf8;
}

.status-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: white;
}

.starting .status-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.ending .status-icon {
  background: linear-gradient(135deg, #4338ca 0%, #3730a3 100%);
}

.status-info {
  flex: 1;
}

.status-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #1e293b;
}

.status-subtitle {
  font-size: 14px;
  margin: 0;
  color: #64748b;
}

/* Form Section */
.form-section {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.form-label i {
  color: #6b7280;
}

.modern-textarea {
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  resize: vertical !important;
  transition: all 0.3s ease !important;
  background: white !important;
  line-height: 1.5 !important;
}

.modern-textarea:focus {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
  outline: none !important;
}

.modern-textarea::placeholder {
  color: #9ca3af !important;
  font-style: italic !important;
}

.form-help {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
}

.form-help i {
  color: #0f65b0;
}

/* Info Section for Start Duty */
.duty-info-section {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}

.info-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.info-header {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
}

.info-header i {
  color: #0f65b0;
}

.info-content {
  padding: 16px;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-item i {
  color: #6b7280;
  width: 16px;
}

/* Modal Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.btn-start-duty,
.btn-end-duty {
  border-radius: 12px !important;
  padding: 14px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
  border: none !important;
}

.btn-start-duty {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
}

.btn-start-duty:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.3) !important;
}

.btn-end-duty {
  background: linear-gradient(135deg, #1d75be 0%, #155a8a 100%) !important;
  color: white !important;
}

.btn-end-duty:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(29, 117, 190, 0.3) !important;
}

.btn-start-duty:disabled,
.btn-end-duty:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-duty-modal >>> .modal-body {
    padding: 16px !important;
  }

  .duty-content {
    gap: 16px;
  }

  .duty-status-card {
    padding: 16px;
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .status-icon {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }

  .status-title {
    font-size: 15px;
  }

  .status-subtitle {
    font-size: 13px;
  }

  .form-section,
  .duty-info-section {
    padding: 16px;
  }

  .info-content {
    padding: 12px;
  }

  .btn-start-duty,
  .btn-end-duty {
    padding: 12px 24px !important;
    font-size: 13px !important;
  }
}

@media (max-width: 480px) {
  .modal-title-modern {
    font-size: 16px;
    flex-direction: column;
    gap: 4px;
    text-align: center;
  }

  .duty-status-card {
    padding: 12px;
  }

  .info-item {
    font-size: 13px;
  }

  .form-label {
    font-size: 13px;
  }

  .modern-textarea {
    font-size: 13px !important;
    padding: 10px 12px !important;
  }

  .btn-start-duty,
  .btn-end-duty {
    width: 100% !important;
    padding: 14px 20px !important;
  }
}
</style>